// import echarts from "echarts";
export function loadChart(myChart, yData, xData, yearList) {
  myChart.clear();
  if (yData.length > 0) {
    // 颜色设置
    myChart.setOption({
      tooltip: {
        trigger: "item",
        axisPointer: {
          // 坐标轴指示器，坐标轴触发有效
          type: "shadow" // 默认为直线，可选为：'line' | 'shadow'
        }
      },
      grid: {
        left: "4%",
        right: "4%",
        bottom: "2%",
        top: "22%",
        containLabel: true
      },
      legend: {
        data: xData,
        left: "7%",
        top: "2%",
        textStyle: {
          color: "#ffffff"
        },
        itemWidth: 15,
        itemHeight: 10,
        itemGap: 6
      },
      xAxis: {
        type: "category",
        data: yearList,
        axisLine: {
          lineStyle: {
            color: "#08aeef"
          }
        },
        axisLabel: {
          textStyle: {
            color: "#ffffff"
          }
        }
      },

      yAxis: [
        {
          type: "value",
          name: `农\n林\n牧\n渔\n业\n生\n产\n值\n︵\n亿\n元\n︶`,
          axisLine: {
            show: true,
            lineStyle: {
              color: "#08aeef"
            }
          },
          axisTick: {
            show: true
          },
          nameTextStyle: {
            color: "#fff",
            padding: [0, 90, -170, 0] // 四个数字分别为上右下左与原位置距离
          },
          splitLine: {
            show: false
          },
          axisLabel: {
            textStyle: {
              color: "#fff"
            }
          }
        },
        {
          type: "value",
          name: `实\n际\n增\n速\n︵\n%\n︶`,
          axisLine: {
            show: true,
            lineStyle: {
              color: "#08aeef"
            }
          },
          nameTextStyle: {
            color: "#fff",
            padding: [0, 0, -140, 50]
          },
          axisTick: {
            show: true
          },
          position: "right",
          splitLine: {
            show: false
          },
          axisLabel: {
            show: true,
            // formatter: "{value} %", //右侧Y轴文字显示
            textStyle: {
              color: "#fff"
            }
          }
        }
      ],
      series: [
        {
          name: "农林牧渔业总产值（亿元）",
          type: "bar",
          barWidth: "16px",
          itemStyle: {
            normal: {
              color: "#5dc1fd",
              barBorderRadius: 0
            }
          },
          data: yData[0]
        },
        {
          name: "农林牧渔业增加值（亿元）",
          type: "bar",
          barWidth: "16px",
          itemStyle: {
            normal: {
              color: "#53cca9",
              barBorderRadius: 0
            }
          },
          data: yData[1]
        },
        {
          name: "农林牧渔业总产值实际增速",
          type: "line",
          yAxisIndex: 1, //使用的 y 轴的 index，在单个图表实例中存在多个 y轴的时候有用
          smooth: false, //平滑曲线显示

          symbol: "circle", //标记的图形为实心圆
          symbolSize: 8, //标记的大小
          itemStyle: {
            normal: {
              color: "#c0504d",
              borderColor: "rgba(181, 83, 86, 0.5)", //圆点透明 边框
              borderWidth: 5
            }
          },
          lineStyle: {
            color: "#c0504d"
          },

          data: yData[2]
        },
        {
          name: "农林牧渔业增加实际增速",
          type: "line",
          yAxisIndex: 1, //使用的 y 轴的 index，在单个图表实例中存在多个 y轴的时候有用
          smooth: false, //平滑曲线显示

          symbol: "circle", //标记的图形为实心圆
          symbolSize: 8, //标记的大小
          itemStyle: {
            normal: {
              color: "#8064a2",
              borderColor: "rgba(228, 221, 235, 0.5)", //圆点透明 边框
              borderWidth: 5
            }
          },
          lineStyle: {
            color: "#8064a2"
          },

          data: yData[3]
        }
      ]
    });
  } else {
    //空状态
    // myChart.clear();
    const msgOption = {
      title: {
        show: true,
        textStyle: {
          color: "grey",
          fontSize: 20
        },
        text: "暂无数据",
        left: "center",
        top: "center"
      },
      xAxis: {
        show: false
      },
      yAxis: {
        show: false
      },
      series: []
    };
    myChart.setOption(msgOption);
  }
}
